import React, { useState } from "react";
import axios from "axios";
import { saveAuth, getSavedUser } from "./lib/globalfunction";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import Header from "./Header";

export default function Home({ onLogin }) {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };


  return (
    <div data-theme="dark">
      <div className="fixed inset-0 w-full h-full pointer-events-none z-0 transition-colors duration-500">
        <div
          className="absolute top-[-10%] left-[-10%] w-96 h-96 rounded-full blur-[100px]"
          style={{ background: "var(--bg-grad-1)" }}
        ></div>
        <div
          className="absolute bottom-[-10%] right-[-10%] w-96 h-96 rounded-full blur-[100px]"
          style={{ background: "var(--bg-grad-2)" }}
        ></div>
      </div>

      <div
        className="relative z-10 w-full max-w-md mx-auto flex flex-col shadow-2xl transition-all duration-500 overflow-hidden"
        style={{
          height: "100dvh",
          background: "rgba(2, 6, 23, 0.8)",
          borderLeft: "1px solid var(--glass-border)",
          borderRight: "1px solid var(--glass-border)",
        }}
      >
        <div
          id="screen-home"
          className=" absolute inset-0 flex flex-col bg-transparent z-30"
        >

      <Header BackTo={""} />
          

          <div className="flex-1 flex flex-col justify-center items-center gap-6 p-6">
            <button
              onClick={() => handleCardClick("/newreferral")}
              className="relative w-full h-32 rounded-3xl bg-gradient-to-br from-cyan-600 to-blue-700 flex flex-col items-center justify-center shadow-lg active:scale-95 transition-transform cursor-pointer group overflow-hidden"
            >
              <div className="absolute inset-0 bg-white/0 group-hover:bg-white/10 transition-colors"></div>
              <svg
                className="w-12 h-12 mb-3 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                ></path>
              </svg>
              <span className="text-2xl font-bold text-white">
                New Referral
              </span>
            </button>
            <button
                onClick={() => handleCardClick("/referlist")}
              className="w-full h-32 rounded-3xl glass flex flex-col items-center justify-center hover:bg-white/10 active:scale-95 transition-all cursor-pointer"
            >
              <svg
                className="w-8 h-8 mb-2 text-accent"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                ></path>
              </svg>
              <span className="text-lg font-semibold text-accent">
                Refer List
              </span>
            </button>
          </div>
        </div>

 
        {/* Login Screen */}
        {/* <div className="absolute inset-0 flex flex-col items-center justify-center z-50 bg-transparent p-8 animate-enter">
          <div
            className="w-28 h-28 rounded-full mb-8 flex items-center justify-center relative"
            style={{
              background: "var(--input-bg)",
              border: "1px solid var(--text-accent)",
              boxShadow: "0 0 20px rgba(6,182,212,0.2)",
            }}
          >
            <div className="w-16 h-16 text-accent">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M12 4v16m8-8H4"
                ></path>
              </svg>
            </div>
            <div className="absolute inset-0 rounded-full border-t-2 border-accent opacity-50 animate-[spin_4s_linear_infinite]"></div>
          </div>

          <div className="text-center mb-10">
            <h1
              className="text-4xl font-bold tracking-tight mb-2"
              style={{ color: "var(--text-main)" }}
            >
              Smart<span className="text-accent">Refer</span>
            </h1>
            <p className="text-xs uppercase tracking-[0.3em] text-muted">
              Intelligent Patient Referral
            </p>
          </div>

          <div className="w-full space-y-5 glass p-6 rounded-2xl">
            <div>
              <label className="input-label">User ID</label>
              <input
                type="text"
                className="input-field"
                placeholder="Enter ID"
               
              />
            </div>
            <div>
              <label className="input-label">Passcode</label>
            </div>
            <button
        
              className="w-full py-3 mt-4 rounded-xl bg-cyan-600 text-white font-bold shadow-lg hover:bg-cyan-500 transition-transform active:scale-95 flex justify-center items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "AUTHENTICATING..." : "LOGIN"}
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                ></path>
              </svg>
            </button>
            {message && (
              <p className="mt-2 text-sm text-center text-red-400">{message}</p>
            )}
          </div>

          <p className="mt-8 text-[10px] text-muted opacity-50">v1.0.1</p>
        </div> */}
      </div>
    </div>
  );
}
